export const CONTENT_SIGNUP = 'signup'
export const CONTENT_LOGIN = 'login'
export const CONTENT_ADDCARD = 'addCard'
export const CONTENT_DONE = 'done'
